<template>
  <div class="content">
    <!-- 面包屑 -->
    <!-- <div class="breadcrumb">
      <i class="iconfont icondqwz"></i>
      <ul>
        <li class="active">设备管理</li>
      </ul>
    </div>-->
    <el-tabs class="tabLv3" type="border-card" v-model="tabName">
      <i class="lt"></i>
      <i class="rt"></i>
      <el-tab-pane name="jsgl">
        <span slot="label">
          <i class="iconfont iconcheck"></i>
          <i class="border"></i> 维保记录管理
        </span>
        <div class="w_normalNav" :parent="self">
          <button class="BlueSmBtn" @click="subSeefrom">搜索</button>
          <button class="OrangeSmBtn" @click="reset">重置</button>
          <button class="GreenSmBtn" @click="addnew">新增</button>
        </div>
        <div class="searchForm1">
          <searchForm :items="items" :formPlus="form_jsgl" ref="searchForm_jsgl">
            <template slot="last">
              <el-form-item label="单位名称" prop="maintCompanyName">
                <el-input v-model="seefrom.maintCompanyName" placeholder="请输入单位名称"></el-input>
              </el-form-item>
              <el-form-item label="开始时间" prop="startDate">
                <el-date-picker v-model="seefrom.startDate" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择开始时间">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="结束时间" prop="endDate">
                <el-date-picker v-model="seefrom.endDate" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择结束时间">
                </el-date-picker>
              </el-form-item>
            </template>
          </searchForm>
        </div>
        <div class="tableWrapper">
          <el-table
            :data="tableData"
            style="width: 100%"
            class="stripeTable"
            max-height="500px"
            ref="Table"
          >
            <el-table-column
              show-overflow-tooltip
              :label="label"
              :prop="prop"
              :align="align"
              v-for="({prop,label,align}) in config"
              :key="prop.toString()"
            ></el-table-column>
            <el-table-column label="操作" width="150">
              <template slot-scope="scope">
                <el-link
                  icon="iconfont iconedit"
                  type="text"
                  size="small"
                  @click="edit(scope.$index, scope.row)"
                >编辑</el-link>
                <el-link
                  icon="iconfont icondelete"
                  type="text"
                  size="small"
                  @click="deleteMsg(scope.$index,scope.row)"
                >删除</el-link>
              </template>
            </el-table-column>
          </el-table>
          <div class="footer">
            <el-pagination
              layout="prev, pager, next"
              :page-size="10"
              @current-change="handleCurrentChange"
              :total="nTotal"
            ></el-pagination>
          </div>
        </div>
        <el-dialog
          class="editDialog"
          :visible.sync="commandDialog"
          :title="title"
          :close-on-click-modal="false"
        >
          <el-form class="adddevice" ref="base" :model="base" :rules="rules">
            <el-form-item prop="maintCompanyId" label="维保单位名称">
              <el-select v-model="base.maintCompanyId" placeholder="请选择维保单位">
                <el-option
                  v-for="item in initCompany"
                  :key="item.id"
                  :value="item.id"
                  :label="item.maintCompanyName"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="maintDate" label="维保时间">
              <el-date-picker
                v-model="base.maintDate"
                :value-format="valueFormat"
                type="datetime"
                placeholder="选择时间"
              ></el-date-picker>
            </el-form-item>
            <el-form-item prop="person" label="维保人员">
              <el-input placeholder="请输入维保人员" v-model.trim="base.person"></el-input>
            </el-form-item>
            <el-form-item prop="maintResult" label="维保结果">
              <el-input placeholder="请输入维保结果" v-model.trim="base.maintResult"></el-input>
            </el-form-item>
            <el-form-item prop="attachments" label="备注">
              <el-input placeholder="请输入备注" v-model.trim="base.attachments"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer" v-if="seeBtn">
            <el-button class="cancelButton" @click="commandDialog = false">取 消</el-button>
            <el-button class="confirmButton" type="primary" @click="submitAdd">确 定</el-button>
          </div>
        </el-dialog>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { dt, obj2urlsp } from "utils";

export default {
  data() {
    return {
      items: [],
      form_jsgl: {},
      rules: {
        maintCompanyId: [
          { required: true, message: "请输入维保单位名称", trigger: "blur" },
        ],
        maintDate: [
          { required: true, message: "请输入维保时间", trigger: "blur" },
        ],
        person: [
          { required: true, message: "请输入维保人员", trigger: "blur" },
        ],
        maintResult: [
          { required: true, message: "请输入维保结果", trigger: "blur" },
        ],
        attachments: [
          { required: true, message: "请输入维保备注", trigger: "blur" },
        ],
      },
      key: "",
      title: "",
      tabName: "jsgl",
      showTable: true,
      other: {},
      seeBtn: true,
      commandDialog: false,
      seefrom: {
        maintCompanyName: "",
        startTime: "",
        endTime: "",
      },
      base: {
        maintCompanyName: "",
        maintCompanyId: "",
        maintDate: "",
        person: "",
        maintResult: "",
        attachments: "",
      },
      valueFormat: "yyyy-MM-dd HH:mm:ss",
      tableData: [],
      nTotal: 0,
      currentPage: 1,
      initCompany: [],
    };
  },
  computed: {
    self() {
      return this;
    },
    config() {
      return [
        {
          prop: "maintCompanyName",
          label: "维保单位",
        },
        {
          prop: "maintDate",
          label: "维保时间",
        },
        {
          prop: "person",
          label: "维保人员",
        },
        {
          prop: "maintResult",
          label: "维保结果",
        },
        {
          prop: "attachments",
          label: "备注",
        },
      ];
    },
    dt() {
      return dt.map(({ label }) => label);
    },
  },
  components: {
    normalNav: () => import("public/normalNav"),
    searchForm: () => import("public/searchForm"),
    easyTable: () => import("public/easyTable"),
  },
  methods: {
    //初始化单位
    getAddCompany() {
      this.$axios
        .get(process.env.API_HOST + "operation/maintCompany/getMaintCompany")
        .then((res) => {
          this.initCompany = res.data;
        });
    },
    //搜索
    subSeefrom() {
      this.getTableData();
    },
    //重置
    reset() {
      this.seefrom.maintCompanyName = "";
      this.seefrom.startDate = "";
      this.seefrom.endDate = "";
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getTableData();
    },
    //查询表格数据
    getTableData() {
      //console.log(this.seefrom.startDate, "startTime");
      this.$axios
        .get(process.env.API_HOST + "operation/maintRecord/selectAll", {
          params: {
            pageSize: 10,
            pageNum: this.currentPage,
            maintCompanyName: this.seefrom.maintCompanyName,
            startDate: this.seefrom.startDate,
            endDate: this.seefrom.endDate,
          },
        })
        .then((res) => {
          this.tableData = res.data.list;
          this.nTotal = res.data.total;
        });
    },
    //新增
    addnew() {
      this.seeBtn = true;
      this.title = "新增维保记录";
      if (this.$refs["base"]) this.$refs["base"].clearValidate();
      this.commandDialog = true;
      this.state = 1;
      this.base = {
        maintCompanyName: "",
        maintCompanyId: "",
        maintDate: "",
        person: "",
        maintResult: "",
        attachments: "",
      };
    },
    //编辑
    edit(index, row) {
      //console.log(row,"row")
      this.title = "修改维保记录";
      this.seeBtn = true;
      if (this.$refs["base"]) this.$refs["base"].clearValidate();
      this.commandDialog = true;
      this.state = 2;
      this.id = row.id;
      this.base.maintCompanyName = row.maintCompanyName;
      this.base.maintCompanyId = row.maintCompanyId;
      this.base.maintDate = row.maintDate;
      this.base.person = row.person;
      this.base.maintResult = row.maintResult;
      this.base.attachments = row.attachments;
    },
    //确认
    submitAdd() {
      this.$refs.base.validate((valid) => {
        if (valid) {
          if (this.state === 1) {
            this.$axiospost("operation/maintRecord/insert", {
              maintCompanyId: this.base.maintCompanyId,
              maintDate: this.base.maintDate,
              person: this.base.person,
              maintResult: this.base.maintResult,
              attachments: this.base.attachments,
            }).then((res) => {
              //console.log(res);
              if (res.data.status === "10000") {
                this.commandDialog = false;
                this.subSeefrom();
                // let loading = Loading.service({});
                // loading.close();
              }
            });
          } else if (this.state === 2) {
            this.$axiospost("operation/maintRecord/update", {
              id: this.id,
              maintCompanyId: this.base.maintCompanyId,
              maintDate: this.base.maintDate,
              person: this.base.person,
              maintResult: this.base.maintResult,
              attachments: this.base.attachments,
            }).then((res) => {
              //console.log(res);
              if (res.data.status === "10000") {
                this.commandDialog = false;
                this.subSeefrom();
                this.$message({
                  type: "success",
                  message: "修改成功!",
                });
                // let loading = Loading.service({});
                // loading.close();
              }
            });
          }
        }
      });
    },
    //删除
    deleteMsg(index, row) {
      this.$confirm("删除该条数据?", "删除操作", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$axios
          .delete(
            process.env.API_HOST + "operation/maintRecord/delete",
            {
              params: {
                id: row.id,
              },
            }
          )
          .then((res) => {
            if (res.data.status === "10000") {
              this.getTableData();
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            }
          });
      });
    },
  },
  created() {
    this.getTableData();
    this.getAddCompany();
  },
};
</script>

<style lang="less">
.w_normalNav {
  padding-top: 10px;
  height: 52px;
  position: absolute;
  top: -52px;
  right: 32px;
  z-index: 99;
}
.el-input__inner:focus {
  border: 1px solid #3587c7;
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute3/management/upkeep/upkeepRecord.vue